document.addEventListener("DOMContentLoaded", () => {
  const bindKeyboardActivation = (elements) => {
    elements.forEach((element) => {
      element.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        element.click();
      });
    });
  };

  const socialLinks = document.querySelectorAll(".social-link");
  const dropdown = document.querySelector(".main_center-menu .dropdown");
  const dropdownItems = dropdown ? dropdown.querySelectorAll("li:not(.content li)") : [];
  const contentContainer = dropdown ? dropdown.querySelector(".content-container") : null;
  const headerLinks = document.querySelectorAll(".header-links");
  const menuLinks = document.querySelectorAll(
    ".main_center-menu .dropdown .content li a, .sliding-menu .depth-sub-menu-children li a"
  );
  let hoverTimeout;

  socialLinks.forEach((link, index) => {
    link.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimeout);

      hoverTimeout = setTimeout(() => {
        if (!dropdown || !contentContainer) return;
        const group = link.getAttribute("data-dropdown");
        dropdown.classList.remove(
          ...Array.from(dropdown.classList).filter((c) =>
            c.startsWith("index-sl-")
          )
        );

        dropdown.classList.add(`index-sl-${index + 1}`);
        dropdown.style.display = "flex";

        contentContainer.className = `content-container s-${group}`;

        dropdownItems.forEach((item) => {
          if (item.getAttribute("data-group") === group) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        });

        contentContainer.querySelectorAll(".content").forEach((content) => {
          content.classList.remove("active");
        });

        const firstItem = dropdown.querySelector("li.active");
        if (firstItem) {
          dropdownItems.forEach((item) => item.classList.remove("selected"));
          firstItem.classList.add("selected");

          const targetId = firstItem.getAttribute("data-content");
          const groupId = firstItem.getAttribute("data-group");

          // Find the element that matches both data-content and data-group
          const targetElement = document.querySelector(
            `[id="${targetId}"][data-group="${groupId}"]`
          );

          if (targetElement) {
            targetElement.classList.add("active");
          }
        }
      }, 120);
    });

    link.addEventListener("mouseleave", () => {
      clearTimeout(hoverTimeout);
    });
  });

  document.body.addEventListener("mousemove", (event) => {
    if (!dropdown) return;
    if (
      !dropdown.contains(event.target) &&
      !Array.from(socialLinks).some((link) => link.contains(event.target)) &&
      !Array.from(headerLinks).some((link) => link.contains(event.target))
    ) {
      dropdown.style.display = "none";
    }
  });
  // Delegate click event for dropdown items
  dropdownItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimeout);

      hoverTimeout = setTimeout(() => {
        if (!contentContainer) return;
        // Remove 'selected' class from all dropdown items
        dropdownItems.forEach((item) => item.classList.remove("selected"));
        item.classList.add("selected");

        // Remove 'active' class from all content elements
        contentContainer.querySelectorAll(".content").forEach((content) => {
          content.classList.remove("active");
        });

        const contentId = item.getAttribute("data-content");
        const groupId = item.getAttribute("data-group");

        // Find the element that matches both data-content and data-group
        const targetElement = document.querySelector(
          `[id="${contentId}"][data-group="${groupId}"]`
        );

        if (targetElement) {
          targetElement.classList.add("active");
        }
      }, 140);
    });
    item.addEventListener("mouseleave", () => {
      clearTimeout(hoverTimeout);
    });
  });

  document.addEventListener("click", (e) => {
    if (!dropdown) return;
    if (!e.target.closest(".social-link") && !e.target.closest(".dropdown")) {
      dropdown.style.display = "none";
    }
  });

  const closeBtn = document.querySelector(".dropdown-close-btn");
  if (closeBtn && dropdown) {
    closeBtn.addEventListener("click", () => {
      dropdown.style.display = "none";
    });
  }

  const menuTrigger = document.querySelector(".menu-trigger");
  const promoTrigger = document.querySelector(".js-promo-open-menu");
  const iconMenu = document.querySelector(".icon-menu");
  const menuContainer = document.getElementById("menuContainer");
  const submenuContainer = document.getElementById("submenuContainer");
  const backButton = document.getElementById("backButton");
  const menuItems = document.querySelectorAll(".sliding-menu .menu > li");
  const submenus = document.querySelectorAll(".sliding-menu .submenu");
  const subMenuTitles = document.querySelectorAll(
    ".sliding-menu .depth-sub-menu-title"
  );
  const menuOverlay = document.querySelector(".sliding-overlay");
  const slidingMenu = document.querySelector(".sliding-menu");

  bindKeyboardActivation(document.querySelectorAll('[role="button"]:not(button)'));

  const updateMenuTriggerState = (isOpen) => {
    [menuTrigger, iconMenu, promoTrigger].filter(Boolean).forEach((trigger) => {
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  };

  const toggleMenu = (event) => {
    if (!menuContainer || !menuOverlay) return;
    event.stopPropagation();
    menuContainer.classList.toggle("active");
    menuOverlay.classList.toggle("active");
    document.body.classList.toggle("modal-open");
    updateMenuTriggerState(menuContainer.classList.contains("active"));
  };

  document.addEventListener("click", (event) => {
    if (!slidingMenu || slidingMenu.contains(event.target)) return;
    menuContainer?.classList.remove("active");
    menuOverlay?.classList.remove("active");
    submenuContainer?.classList.remove("active");
    document.body.classList.remove("modal-open");
    updateMenuTriggerState(false);
  });

  if (menuTrigger) menuTrigger.addEventListener("click", toggleMenu);
  if (iconMenu) iconMenu.addEventListener("click", toggleMenu);
  if (promoTrigger) {
    promoTrigger.addEventListener("click", toggleMenu);
  }

  const directRedirect = ["itunes-top-100", "apple-music", "buy-apple-music-streams"];

  menuItems.forEach((item) => {
    item.addEventListener("click", () => {
      const submenuId = item.getAttribute("data-submenu");

      menuItems.forEach((menuItem) => menuItem.setAttribute("aria-expanded", "false"));

      if (submenuId) {
        if (directRedirect.includes(submenuId)) {
          const submenu = document.getElementById(submenuId);
          const link = submenu?.querySelector("a.view-all-link");
          if (link) {
            window.location.href = link.href;
          }
          return;
        }

        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
        });

        const submenu = document.getElementById(submenuId);
        if (submenu) {
          submenu.classList.add("active");
          submenuContainer?.classList.add("active");
          backButton?.classList.add(`submenu-${submenuId}`);
          item.setAttribute("aria-expanded", "true");
        }
      }
    });
  });

  if (backButton) backButton.addEventListener("click", () => {
    submenuContainer?.classList.remove("active");
    menuItems.forEach((item) => item.setAttribute("aria-expanded", "false"));
    backButton.className = backButton.className
      .split(" ")
      .filter((className) => !className.startsWith("submenu-"))
      .join(" ");
  });

  subMenuTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const parent = title.closest(".depth-sub-menu");
      parent.classList.toggle("open");
      title.setAttribute("aria-expanded", parent.classList.contains("open") ? "true" : "false");
    });
  });

  const searchInput = document.getElementById("searchInput");
  if (searchInput) searchInput.addEventListener("input", function (event) {
    let searchTerm = event.target.value.toLowerCase();
    let menuItems = document.querySelectorAll(".sliding-menu .primary-item");

    menuItems.forEach(function (item) {
      let title = item.textContent.toLowerCase();
      if (title.indexOf(searchTerm) > -1) {
        item.style.display = "flex";
      } else {
        item.style.display = "none";
      }
    });
  });

  const menuCloseButton = document.getElementById("closeButton");
  if (menuCloseButton) menuCloseButton.addEventListener("click", function () {
    submenuContainer?.classList.remove("active");
    if (backButton) {
      backButton.className = backButton.className
        .split(" ")
        .filter((className) => !className.startsWith("submenu-"))
        .join(" ");
    }
    menuContainer?.classList.toggle("active");
    menuOverlay?.classList.remove("active");
    document.body.classList.remove("modal-open");
    menuItems.forEach((item) => item.setAttribute("aria-expanded", "false"));
    updateMenuTriggerState(false);
  });

  const langToggler = document.querySelector(".c-dropdown__toggler");
  const langBody = document.querySelector(".c-dropdown__body");

  if (langToggler && langBody) {
    langToggler.addEventListener("click", function (e) {
      langBody.classList.toggle("active");
      this.setAttribute("aria-expanded", langBody.classList.contains("active") ? "true" : "false");
    });

    document.addEventListener("click", function (e) {
      if (!langBody.contains(e.target) && !langToggler.contains(e.target)) {
        langBody.classList.remove("active");
        langToggler.setAttribute("aria-expanded", "false");
      }
    });
  }

  document.addEventListener("click", function (event) {
    const isInsideMenu =
      (submenuContainer && submenuContainer.contains(event.target)) ||
      (menuContainer && menuContainer.contains(event.target)) ||
      (menuTrigger && menuTrigger.contains(event.target)) ||
      (promoTrigger && promoTrigger.contains(event.target)) ||
      (iconMenu && iconMenu.contains(event.target));

    const isSubmenuItem = event.target.closest(
      ".sliding-menu .depth-sub-menu-children li"
    );

    if (!isInsideMenu || isSubmenuItem) {
      submenuContainer?.classList.remove("active");
      if (backButton) {
        backButton.className = backButton.className
          .split(" ")
          .filter((className) => !className.startsWith("submenu-"))
          .join(" ");
      }
      menuContainer?.classList.remove("active");
      menuOverlay?.classList.remove("active");
      document.body.classList.remove("modal-open");
      menuItems.forEach((item) => item.setAttribute("aria-expanded", "false"));
      updateMenuTriggerState(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    const menuWasOpen = Boolean(
      menuContainer?.classList.contains("active") || submenuContainer?.classList.contains("active")
    );
    menuContainer?.classList.remove("active");
    submenuContainer?.classList.remove("active");
    menuOverlay?.classList.remove("active");
    document.body.classList.remove("modal-open");
    menuItems.forEach((item) => item.setAttribute("aria-expanded", "false"));
    subMenuTitles.forEach((title) => title.setAttribute("aria-expanded", "false"));
    updateMenuTriggerState(false);

    langBody?.classList.remove("active");
    langToggler?.setAttribute("aria-expanded", "false");

    if (menuWasOpen) iconMenu?.focus();
  });

  document.querySelectorAll(".show-more-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      var gridWrapper = this.closest(".tag-products-grid")?.querySelector(".product-grid-wrapper");

      if (gridWrapper) {
        // Розгортаємо до кінця і прибираємо шеврон — згортати назад нема сенсу
        gridWrapper.classList.add("expanded");
        this.style.display = "none";
      }
    });
  });

  document.addEventListener("click", function (event) {
    const allVariantsLists = document.querySelectorAll(".product-variants-list");
    const clickedToggle = event.target.closest(".toggle-variants");
    const clickedProduct = event.target.closest(".item-product");

    if (clickedToggle) {
      const itemProduct = clickedToggle.closest(".item-product");
      const variantsList = itemProduct.querySelector(".product-variants-list");

      if (variantsList) {
        const isOpen = variantsList.classList.contains("show");

        allVariantsLists.forEach(list => {
          list.classList.remove("show");

          const swiperContainer = list.closest(".swiper-container");
          if (swiperContainer) {
            const prevBtn = swiperContainer.querySelector(".swiper-button-prev");
            const nextBtn = swiperContainer.querySelector(".swiper-button-next");
            if (prevBtn) prevBtn.style.display = "";
            if (nextBtn) nextBtn.style.display = "";
          }
        });

        if (!isOpen) {
          variantsList.classList.add("show");

          // Список довший за видиму зону — доскролюємо, щоб було видно весь
          setTimeout(() => {
            const r = variantsList.getBoundingClientRect();
            if (r.bottom > window.innerHeight - 16 || r.top < 0) {
              variantsList.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
          }, 80);

          const swiperContainer = itemProduct.closest(".swiper-container");
          if (swiperContainer) {
            const prevBtn = swiperContainer.querySelector(".swiper-button-prev");
            const nextBtn = swiperContainer.querySelector(".swiper-button-next");
            if (prevBtn) prevBtn.style.display = "none";
            if (nextBtn) nextBtn.style.display = "none";
          }
        }
      }
    } else {
      if (!clickedProduct) {
        allVariantsLists.forEach(list => {
          list.classList.remove("show");

          const swiperContainer = list.closest(".swiper-container");
          if (swiperContainer) {
            const prevBtn = swiperContainer.querySelector(".swiper-button-prev");
            const nextBtn = swiperContainer.querySelector(".swiper-button-next");
            if (prevBtn) prevBtn.style.display = "";
            if (nextBtn) nextBtn.style.display = "";
          }
        });
      }
    }
  });



  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(function (faqItem) {
    faqItem.addEventListener('click', function () {
      faqItem.classList.toggle('active');
    });
  });

  function numberWithCommas(x) {
    return x.replace(/\d+/g, function (match) {
      return match.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    });
  }

  var productCountElements = document.querySelectorAll('.count-num');

  productCountElements.forEach(function (element) {
    var text = element.textContent.trim();
    var updatedText = numberWithCommas(text);
    element.textContent = updatedText;
  });


});


document.addEventListener("DOMContentLoaded", () => {
  const backToTopButton = document.getElementById('back2Top');
  if (!backToTopButton) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 300) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  });
  backToTopButton.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const isProduct = window.location.pathname.includes('/products/')
  const hasChatParam = window.location.search.includes('chat')

  if (!isProduct || hasChatParam) return

  document.body.classList.add('chat-hidden-tag')

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      document.body.classList.remove('chat-hidden-tag')
    } else {
      document.body.classList.add('chat-hidden-tag')
    }
  })
});
